import React from "react";
import "./JobSearchResultList.scss";
import useQueryJobPublicSearch from "./useQueryJobPublicSearch.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import useTranslationJobs from "../useTranslationJobs.js";
import { SEARCH_PAGE_SIZE } from "../../../constants/ui.js";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ActionButton from "../../common/widgets/ActionButton.js";
import TypeUtils from "../../../utils/TypeUtils.js";
import useLanguages from "../../infra-no-ui/translation/useLanguages.js";

export default function JobSearchResultList(props) {
  const {
    searchFilters,
    sortValue,
    pageSizeValue,
    updatePageSizeValue,
    resultComponent,
  } = props;

  const { t, loading: tLoading } = useTranslationJobs();
  const {getCurrentLanguageCode} = useLanguages();

  const {
    loading,
    loadingMore,
    errors,
    data: jobs,
    hasNextPage,
    loadMore,
  } = useQueryJobPublicSearch(pageSizeValue, searchFilters, sortValue, getCurrentLanguageCode());

  useShowLoader(tLoading, "JobSearchResultList");

  const onClickLoadMore = (event) => {
    event.preventDefault();
    loadMore();
    updatePageSizeValue(pageSizeValue + SEARCH_PAGE_SIZE);
  };

  // Enclose only the load more button inside WaitForData, to avoid the previous results from being hidden by the spinner
  return (
    <div className="JobSearchResultList">
      {TypeUtils.ensureArray(jobs).map((item, index) =>
        React.cloneElement(resultComponent, {
          key: index,
          item,
        })
      )}
      <WaitForData
        loading={loading}
        errors={errors}
        onLoaded={() => (
          <>
            {TypeUtils.arrayIsEmpty(jobs) && <span>{t("jobs:job_no_result")}</span>}
            {hasNextPage && (
              <>
                <Row className="button-row">
                  <Col>
                    <ActionButton
                      loading={loadingMore}
                      onClick={onClickLoadMore}
                    >
                      {t("jobs:job_load_more")}
                    </ActionButton>
                  </Col>
                </Row>
                <Row className="expand-icon-row">
                  <Col>
                    <ExpandMoreIcon />
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
      />
    </div>
  );
}
